class SwiperSlider extends HTMLElement {
    constructor() {
        super();
        this.self = this;
        this.observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.initSwiper();
              }
            });
        });
        this.observer.observe(this);
    }

    initSwiper() {
        if (this.swiper) this.swiper.destroy();
        let self = this.self;
        const sliderIdentifier = self.dataset.id;
        let perPage = self.dataset.row;
        let space = self.dataset.space;
        let perPageMb = self.dataset.rowMb;
        let spaceMB = self.dataset.spaceMb;
        const enableAutoplay = this.dataset.enableAutoplay === "true";
        const autoplayDelay = parseInt(this.dataset.autoplayDelay, 10) * 1000 || 5000;
        this.swiper = new Swiper(`[data-id="${sliderIdentifier}"]`, {
            slidesPerView: perPageMb,
            spaceBetween: spaceMB,
            loop: false,
            mousewheel: { forceToAxis: true },
            ...(enableAutoplay && {
                autoplay: {
                  delay: autoplayDelay,
                  disableOnInteraction: true,
                  pauseOnMouseEnter: true,
                },
            }),
            breakpoints: {
                768: {
                    slidesPerView: 2,
                    spaceBetween: 0
                },
                1024: {
                    slidesPerView: 'auto',
                    spaceBetween: space
                }
            }
        });
        this.observer.disconnect();
    }
    destroySwiper() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
    }
}
  
customElements.define("swiper-slider", SwiperSlider);